import { Component } from '@angular/core';
import { RoutedModalBaseComponent, SlottedModalComponent } from '@woolworthsnz/styleguide';
import { PickupStoreSelectionComponent } from '@woolworthsnz/fulfilment';

@Component({
	selector: 'wnz-change-pickup-store-modal',
	templateUrl: './change-pickup-store-modal.component.html',
	standalone: true,
	imports: [SlottedModalComponent, PickupStoreSelectionComponent],
})
export class ChangePickupStoreModalComponent extends RoutedModalBaseComponent {}
